import { call, put, takeLatest } from "redux-saga/effects";
import { GET_VAULT } from "../../../Redux/Actions/actionTypes";
import GetVaultRequest from "../../../Communication/ApiClasses/GetVaultRequest";
import {
  doLoadingFinish,
  doLoadingStart,
} from "../../Common/ProgressIndicator/Actions/ProgressIndicatorActions";

// worker
function* handleSaga(action) {
  yield put(doLoadingStart(`${GET_VAULT}_SAGA`));
  const request = new GetVaultRequest(action.data);
  try {
    const result = yield call(request.getData);
    yield put({
      type: `${GET_VAULT}_SUCCESS`,
      data: result.data,
    });
    yield call(action.callback, result.data);
  } catch (e) {
    yield put({
      type: `${GET_VAULT}_ERROR`,
      error: e.message,
    });
  } finally {
    yield put(doLoadingFinish(`${GET_VAULT}_SAGA`));
  }
}

// watcher
export default function* executeSaga() {
  yield takeLatest(GET_VAULT, handleSaga);
}
